


// ---------product-page-tabs-----------------

document.addEventListener("DOMContentLoaded",()=>{
    const tabs = document.querySelectorAll(".product-tabs li");
    const tabs_content = document.querySelectorAll(".tabs-content");

    tabs.forEach((tab,idx)=>{
        tab.addEventListener("click",()=>{

            tabs.forEach(t=>{t.classList.remove("active")})

            tabs_content.forEach(con=>{con.classList.remove("active")})

            tab.classList.add("active");
            tabs_content[idx].classList.add("active");


        })
    })
})

// ---------product-page-tabs-----------------

// -----------------menu------------------

// document.addEventListener("DOMConttentLoaded",()=>{
    function dMenuToggle(){
        document.querySelector(".menu-container").classList.toggle("active");
        document.querySelector(".menu-overlay").classList.toggle("active");
        document.querySelector(".header-main-container").classList.toggle("active");
        document.querySelector(".header-menu").classList.toggle("active");
    }


// })

// -----------------menu------------------

// ----------------menu-accordian-start--------------

document.addEventListener("DOMContentLoaded", () => {

  const items = document.querySelectorAll(".menu-mid-part-accordian");

  items.forEach(item => {
    const head = item.querySelector(".accordian-head");
    const content = item.querySelector(".accordian-links");

    head.addEventListener("click", () => {

      items.forEach(i => {
        if (i !== item) {
          i.classList.remove("active");
          i.querySelector(".accordian-links").style.maxHeight = null;
        }
      });

      item.classList.toggle("active");

      content.style.maxHeight = item.classList.contains("active")
        ? content.scrollHeight + "px"
        : null;

    });

  });

});

// ----------------menu-accordian-end--------------


// ========================= Draggable JS ==================================

function enableLeftClickDragScroll(container) {
    if (!container)
        return;
    let isDragging = !1
      , dragStarted = !1
      , startX = 0
      , scrollStart = 0;
    const dragThreshold = 5;
    container.addEventListener("mousedown", e => {
        e.button === 0 && (isDragging = !0,
        dragStarted = !1,
        startX = e.pageX,
        scrollStart = container.scrollLeft,
        container.classList.add("is-dragging"),
        e.preventDefault())
    }
    ),
    container.addEventListener("mousemove", e => {
        if (!isDragging)
            return;
        const deltaX = e.pageX - startX;
        !dragStarted && Math.abs(deltaX) > dragThreshold && (dragStarted = !0),
        dragStarted && (container.scrollLeft = scrollStart - deltaX)
    }
    ),
    container.addEventListener("mouseup", () => {
        isDragging = !1,
        container.classList.remove("is-dragging")
    }
    ),
    container.addEventListener("mouseleave", () => {
        isDragging = !1,
        container.classList.remove("is-dragging")
    }
    ),
    container.addEventListener("click", e => {
        dragStarted && (e.preventDefault(),
        e.stopPropagation(),
        dragStarted = !1)
    }
    ),
    container.classList.add("is-draggable")
}
function waitForElementAndInit(selector) {
    document.querySelectorAll(selector).forEach(el => {
        el._dragInitialized || (enableLeftClickDragScroll(el),
        el._dragInitialized = !0)
    }
    ),
    new MutationObserver(mutations => {
        for (const mutation of mutations)
            mutation.addedNodes.forEach(node => {
                node instanceof HTMLElement && (node.matches(selector) && !node._dragInitialized && (enableLeftClickDragScroll(node),
                node._dragInitialized = !0),
                node.querySelectorAll?.(selector)?.forEach(el => {
                    el._dragInitialized || (enableLeftClickDragScroll(el),
                    el._dragInitialized = !0)
                }
                ))
            }
            )
    }
    ).observe(document.body, {
        childList: !0,
        subtree: !0
    })
}
document.addEventListener("DOMContentLoaded", () => {
    [".product-grid", ".cust-mid-collection-container","#predictive-search-results-products-list"].forEach(selector => {
        waitForElementAndInit(selector)
    }
    )
}
);

// ========================= Draggable JS ==================================



// ========== Size Chart Start ==========

function  sizeChartToggle(btn){
    const mainProduct = btn.closest("product-info");
    const currentChart = mainProduct.querySelector(".pdp-size-chart");
    currentChart.classList.toggle("active");
    document.addEventListener("scroll", () => {
      if (currentChart.classList.contains("active")) {
        currentChart.classList.remove("active");
      }
    });
  }

// ========== Size Chart End ==========




// // --------  pdp variant change start  --------
// function setMeasurement(element, value) {
//     if (value && value.trim() !== "") {
//         element.innerHTML = `${value}<sup>inch</sup>`;
//     } else {
//         element.textContent = "NA";
//     }
// }

// function variantUpdate(el) {
//     const formWrapper = el.closest(".pdp-form-wrapper");

//     setMeasurement(
//         formWrapper.querySelector("#variant-chest span:last-child"),
//         el.dataset.chest
//     );

//     setMeasurement(
//         formWrapper.querySelector("#variant-waist span:last-child"),
//         el.dataset.waist
//     );

//     setMeasurement(
//         formWrapper.querySelector("#variant-length span:last-child"),
//         el.dataset.length
//     );
// }
// // -------- pdp variant change end  -------- 


// document.addEventListener("DOMContentLoaded",()=>{
// const target = document.querySelector("product-recommendations");

// if (target) {
//   const observer = new MutationObserver((mutations,obs) => {
//     for (const mutation of mutations) {
//         obs.disconnect();
//       if (mutation.type === "childList") {
//             document.querySelectorAll('.productSwiper').forEach((slider) => {
//             new Swiper(slider, {
//                 loop: true,
//                 slidesPerView: 1,
//                 spaceBetween: 0,
//                 allowTouchMove: true,
//                 pagination: {
//                     el: ".swiper-pagination",
//                     clickable: true,
//                     dynamicBullets: true,
//                 },
//                 navigation: {
//                 nextEl: slider.querySelector('.swiper-button-next'),
//                 prevEl: slider.querySelector('.swiper-button-prev'),
//                 },
//             });
//         });
//         break;
//       }
//     }
//   });

//   observer.observe(target, {
//     childList: true, // watch children add/remove
//   });
// }
// const collectionProducts = document.querySelector(".active-facets.active-facets-desktop");
// if (collectionProducts) {
//   const observer = new MutationObserver((mutations,obs) => {
//     for (const mutation of mutations) {
//             document.querySelectorAll('.productSwiper').forEach((slider) => {
//             new Swiper(slider, {
//                 loop: true,
//                 slidesPerView: 1,
//                 spaceBetween: 0,
//                 allowTouchMove: true,
//                 pagination: {
//                     el: ".swiper-pagination",
//                     clickable: true,
//                     dynamicBullets: true,
//                 },
//                 navigation: {
//                 nextEl: slider.querySelector('.swiper-button-next'),
//                 prevEl: slider.querySelector('.swiper-button-prev'),
//                 },
//             });
//         });
//         break;
//     }
//   });

//   observer.observe(collectionProducts, {
//     childList: true, // watch children add/remove,
//     subtree: true,
//   });
// }


// document.querySelectorAll('.productSwiper').forEach((slider) => {
//       new Swiper(slider, {
//   loop: true,
//   slidesPerView: 1,
//   spaceBetween: 0,
//   allowTouchMove: true, // ✅ enable touch
//   pagination: {
//     el: ".swiper-pagination",
//     clickable: true,
//     dynamicBullets: true,
//   },
//   navigation: {
//     nextEl: slider.querySelector('.swiper-button-next'),
//     prevEl: slider.querySelector('.swiper-button-prev'),
//   },
// });

//     });

//     // for product-rec

// });


(function () {

  'use strict';

  /*
   * =========================================
   * INITIALIZE PRODUCT SWIPERS
   * =========================================
   */

  function initProductSwipers(container) {

    container = container || document;

    /*
     * If the container itself is a swiper
     */
    if (
      container.nodeType === 1 &&
      container.matches &&
      container.matches('.productSwiper')
    ) {
      initSingleSwiper(container);
    }

    /*
     * Find all swipers inside container
     */
    const sliders = container.querySelectorAll
      ? container.querySelectorAll('.productSwiper')
      : [];

    sliders.forEach(function (slider) {
      initSingleSwiper(slider);
    });
  }


  /*
   * =========================================
   * INITIALIZE ONE SWIPER
   * =========================================
   */

  function initSingleSwiper(slider) {

    if (!slider) {
      return;
    }

    /*
     * Already initialized
     */
    if (slider.swiper) {
      return;
    }

    /*
     * Swiper library not loaded yet
     */
    if (typeof Swiper === 'undefined') {
      console.warn('Swiper JS is not loaded.');
      return;
    }

    const wrapper =
      slider.querySelector('.swiper-wrapper');

    const slides =
      slider.querySelectorAll('.swiper-slide');

    /*
     * Don't initialize if markup is incomplete
     */
    if (!wrapper || !slides.length) {
      console.warn(
        'Swiper markup is incomplete:',
        slider
      );
      return;
    }

    const pagination =
      slider.querySelector('.swiper-pagination');

    const nextButton =
      slider.querySelector('.swiper-button-next');

    const prevButton =
      slider.querySelector('.swiper-button-prev');


    /*
     * =========================================
     * CREATE SWIPER
     * =========================================
     */

    new Swiper(slider, {

      loop: slides.length > 1,

      slidesPerView: 1,

      spaceBetween: 0,

      allowTouchMove: true,

      watchOverflow: true,

      observer: true,

      observeParents: true,

      observeSlideChildren: true,


      pagination: pagination ? {
        el: pagination,
        clickable: true,
        dynamicBullets: true
      } : undefined,


      navigation: nextButton && prevButton ? {
        nextEl: nextButton,
        prevEl: prevButton
      } : undefined,


      /*
       * Recalculate when swiper becomes visible
       */
      on: {

        init: function () {

          slider.classList.add(
            'product-swiper-initialized'
          );

        }

      }

    });

  }


  /*
   * =========================================
   * INITIAL PAGE LOAD
   * =========================================
   */

  function init() {

    initProductSwipers(document);

  }


  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      init
    );

  } else {

    init();

  }


  /*
   * =========================================
   * SHOPIFY SECTION RENDER
   * =========================================
   */

  document.addEventListener(
    'shopify:section:load',
    function (event) {

      if (event.target) {
        initProductSwipers(event.target);
      }

    }
  );


  /*
   * =========================================
   * YOUR CUSTOM COLLECTION EVENT
   * =========================================
   */

  document.addEventListener(
    'collection:updated',
    function (event) {

      const container =
        event.detail &&
        event.detail.container;

      if (container) {
        initProductSwipers(container);
      } else {
        initProductSwipers(document);
      }

    }
  );


  /*
   * =========================================
   * DYNAMIC PRODUCT RECOMMENDATIONS
   * =========================================
   *
   * Shopify recommendations are often inserted
   * after the initial page load.
   */

  const observer = new MutationObserver(
    function (mutations) {

      let shouldInitialize = false;

      mutations.forEach(function (mutation) {

        if (
          mutation.type !== 'childList' ||
          !mutation.addedNodes.length
        ) {
          return;
        }

        mutation.addedNodes.forEach(function (node) {

          if (node.nodeType !== 1) {
            return;
          }

          /*
           * Added element itself is swiper
           */
          if (
            node.matches &&
            node.matches('.productSwiper')
          ) {
            shouldInitialize = true;
            return;
          }

          /*
           * Added element contains swiper
           */
          if (
            node.querySelector &&
            node.querySelector('.productSwiper')
          ) {
            shouldInitialize = true;
          }

        });

      });


      if (shouldInitialize) {
        initProductSwipers(document);
      }

    }
  );


  /*
   * Start watching the page
   */

  if (document.body) {

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

  }


  /*
   * =========================================
   * GLOBAL FUNCTION
   * =========================================
   */

  window.initProductCardSwipers =
    initProductSwipers;


})();



// header-scroll
document.addEventListener("DOMContentLoaded", () => {
  const homePage = document.querySelector(".home-page");

    // if (window.location.pathname === "/") {

  // Only desktop
  // if (window.innerWidth <= 950) return;

  const headerscroll = document.querySelector("header");

  if (!headerscroll) return;

  window.addEventListener("scroll", () => {
    if (window.scrollY > 50) {
      headerscroll.classList.add("scrolled");
    } else {
      headerscroll.classList.remove("scrolled");
    }
  });
// };
});
// header-scroll